<div class="dashboard">
  <router-outlet></router-outlet>
</div>



